// Native
import { useState } from "react"

// Components
import { ButtonGroup, Td } from "@chakra-ui/react"
import { Form, IconButton, Row, Searchable, Section, Table, Tag } from "components"

// Config
import { Mask, Enums, Moment } from "config"

// Hooks
import { useConsultantsOrders, useScreens } from "hooks"

export default function Orders({ data }){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState()
    const [ status, setStatus ] = useState()
    const [ type, setType ] = useState()
    const orders = useConsultantsOrders(data?.id, page, term, status, type)

    // Table columns
    const columns = [
        { children: '', isNumeric: true }, 
        { children: 'Núcleo' }, 
        { children: 'Status' }, 
        { children: 'Total', isNumeric: true }, 
        { children: 'Data', isNumeric: true }, 
        { isNumeric: true }
    ]

    return(
    <>
        <Section title="Pedidos do consultor">
            <ButtonGroup size="xs" isDisabled={orders.isFetching}>
                <IconButton icon="refresh" isLoading={orders.isFetching} onClick={orders.refetch} />
            </ButtonGroup>
        </Section>

        <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID ou Código do pedido..">
            <Form.Select onChange={e => setType(e.target.value)} options={[{ label: 'Todos os pedidos', value: '' }, { label: 'Pedidos de Produtos', value: Enums.OrderType.CONSULTANT }, { label: 'Pedidos de Adesão', value: Enums.OrderType.ADHESION }]} />
            <Form.Select onChange={e => setStatus(e.target.value)} options={[{ label: 'Todos os status', value: '' }, { label: 'Aprovado', value: Enums.OrderStatus.APPROVED },{ label: 'Cancelado', value: Enums.OrderStatus.CANCELED }, { label: 'Em Análise', value: Enums.OrderStatus.ANALYZING }, { label: 'Em Trânsito', value: Enums.OrderStatus.SHIPPING }]} />
        </Searchable>

        <Table columns={columns} setPage={setPage} meta={orders.data?.meta} loading={orders.isLoading}>{ orders?.data?.data?.map(item => <Item data={item} />)}</Table>
    </>
    )
}

const Item = ({ data:item, ...props }) => {

    const { setOrder } = useScreens()

    let status = Enums.OrderStatus.data(item.status)
    let distributor_name = item.distributor_from?.name ? item.distributor_from?.name : 'Consultor Parceiro'

    return(
    <Row key={item.id} onClick={() => setOrder(item)} {...props}>
        <Td isNumeric children={item.cod} />
        <Td><Tag isTruncated maxW="300px" size="sm" label={distributor_name} children={distributor_name} /></Td>
        <Td><Tag size="sm" colorScheme={status.colorScheme}>{item?.status_label}</Tag></Td>
        <Td isNumeric>R$ {Mask.price(item?.itens_amount)}</Td>
        <Td isNumeric children={Moment(item.created_at).calendar()} />
        <Td><ButtonGroup size="xs"><IconButton label="Ver pedido" icon="view" onClick={() => setOrder(item)} /></ButtonGroup></Td>
    </Row>
    )
}